import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import TagContextDetails, { hasHumanContext } from './TagContextDetails';

const FullCard = styled(Card)({
    gridColumn: 'span 3',
});

const CardTitleText = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.h5.fontSize,
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
    },
}));

const ProjectTagContext = () => {
    const context = useSelector((state) => state.project.currentProject?.context);
    if (!hasHumanContext(context)) return null;

    return (
        <FullCard>
            <CardHeader title={<CardTitleText>Context</CardTitleText>} subheader="Where this work happens, from the project’s tags" />
            <StyledCardContent>
                <TagContextDetails context={context} />
            </StyledCardContent>
        </FullCard>
    );
};

export default ProjectTagContext;
